var map = {
	"./layouts/card": 26,
	"./layouts/card/": 26,
	"./layouts/card/index": 26,
	"./layouts/card/index.tsx": 26,
	"./layouts/card/style.module": 154,
	"./layouts/card/style.module.scss": 154,
	"./layouts/components/breadcrumbs": 130,
	"./layouts/components/breadcrumbs/": 130,
	"./layouts/components/breadcrumbs/index": 130,
	"./layouts/components/breadcrumbs/index.tsx": 130,
	"./layouts/components/breadcrumbs/style.module": 191,
	"./layouts/components/breadcrumbs/style.module.scss": 191,
	"./layouts/components/container": 47,
	"./layouts/components/container/": 47,
	"./layouts/components/container/index": 47,
	"./layouts/components/container/index.tsx": 47,
	"./layouts/components/container/style.module": 132,
	"./layouts/components/container/style.module.scss": 132,
	"./layouts/components/footer": 131,
	"./layouts/components/footer/": 131,
	"./layouts/components/footer/index": 131,
	"./layouts/components/footer/index.tsx": 131,
	"./layouts/components/footer/style.module": 90,
	"./layouts/components/footer/style.module.scss": 90,
	"./layouts/components/loading_indicator": 62,
	"./layouts/components/loading_indicator/": 62,
	"./layouts/components/loading_indicator/index": 62,
	"./layouts/components/loading_indicator/index.tsx": 62,
	"./layouts/components/nav_bar": 100,
	"./layouts/components/nav_bar/": 100,
	"./layouts/components/nav_bar/index": 100,
	"./layouts/components/nav_bar/index.tsx": 100,
	"./layouts/components/nav_bar/standalone": 357,
	"./layouts/components/nav_bar/standalone.tsx": 357,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 87,
	"./layouts/components/notice_banner/": 87,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 192,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 192,
	"./layouts/components/notice_banner/index": 87,
	"./layouts/components/notice_banner/index.tsx": 87,
	"./layouts/components/notice_banner/standalone": 358,
	"./layouts/components/notice_banner/standalone.tsx": 358,
	"./layouts/components/notice_banner/style.module": 193,
	"./layouts/components/notice_banner/style.module.scss": 193,
	"./layouts/page": 104,
	"./layouts/page/": 104,
	"./layouts/page/index": 104,
	"./layouts/page/index.tsx": 104,
	"./layouts/page/style.module": 91,
	"./layouts/page/style.module.scss": 91,
	"./layouts/types": 359,
	"./layouts/types.ts": 359,
	"./marketing/pages/home/toefl": 1548,
	"./marketing/pages/home/toefl/": 1548,
	"./marketing/pages/home/toefl/index": 1548,
	"./marketing/pages/home/toefl/index.tsx": 1548,
	"./marketing/pages/home/toefl/sections/ai": 1151,
	"./marketing/pages/home/toefl/sections/ai/": 1151,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1781,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1781,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1782,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1782,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1783,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1783,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1784,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1784,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1785,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1785,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1786,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1786,
	"./marketing/pages/home/toefl/sections/ai/index": 1151,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1151,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1787,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1787,
	"./marketing/pages/home/toefl/sections/apps": 1152,
	"./marketing/pages/home/toefl/sections/apps/": 1152,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1788,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1788,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1789,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1789,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1790,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1790,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1791,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1791,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1792,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1792,
	"./marketing/pages/home/toefl/sections/apps/index": 1152,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1152,
	"./marketing/pages/home/toefl/sections/features": 1153,
	"./marketing/pages/home/toefl/sections/features/": 1153,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1793,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1793,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1794,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1794,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1795,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1795,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1796,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1796,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1797,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1797,
	"./marketing/pages/home/toefl/sections/features/index": 1153,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1153,
	"./marketing/pages/home/toefl/sections/official_questions": 1157,
	"./marketing/pages/home/toefl/sections/official_questions/": 1157,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1806,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1806,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1157,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1157,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 677,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 677,
	"./marketing/pages/home/toefl/sections/value_props": 1154,
	"./marketing/pages/home/toefl/sections/value_props/": 1154,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1798,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1798,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1799,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1799,
	"./marketing/pages/home/toefl/sections/value_props/index": 1154,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1154,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2197,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2197,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1155,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1155,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1800,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1800,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1801,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1801,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1802,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1802,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1803,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1803,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1804,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1804,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1155,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1155,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 676,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 676,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1156,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1156,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1805,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1805,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1156,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1156,
	"./marketing/pages/home/toefl/style.module": 1807,
	"./marketing/pages/home/toefl/style.module.scss": 1807,
	"./marketing/pages/plans/toefl": 1549,
	"./marketing/pages/plans/toefl/": 1549,
	"./marketing/pages/plans/toefl/index": 1549,
	"./marketing/pages/plans/toefl/index.tsx": 1549,
	"./marketing/pages/plans/toefl/sections/testimonials": 1158,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1158,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1808,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1808,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1809,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1809,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1158,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2535;